import { Target, FileText } from "lucide-react";
import { categoryIcons } from "../../lib/constants";

// List of open buyer requests in the marketplace
export const BuyerRequestsList = ({ requests }) => {
  if (requests.length === 0) {
    return (
      <div className="bg-white/5 rounded-2xl p-12 text-center border border-purple-500/20">
        <Target className="w-12 h-12 text-gray-600 mx-auto mb-4" />
        <p className="text-gray-400">No buyer requests yet</p>
      </div>
    );
  }
  return (
    <div className="space-y-4">
      {requests.map((req) => {
        const Icon = categoryIcons[req.category] || FileText;
        return (
          <div key={req.id} className="bg-white/5 rounded-2xl p-6 border border-purple-500/20">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-yellow-500/20 to-orange-500/20 flex items-center justify-center">
                <Icon className="w-6 h-6 text-yellow-400" />
              </div>
              <div className="flex-1">
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="font-semibold text-white">{req.title}</h3>
                    <p className="text-sm text-gray-400">by {req.buyer_name} • {req.category}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-lg font-bold text-cyan-400">Up to ${req.max_budget}</p>
                    <p className="text-xs text-gray-500">{req.responses} responses</p>
                  </div>
                </div>
                <p className="text-gray-400 text-sm mt-2">{req.description}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
